import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import AppView from '~common/components/app-view/index';
import {Button, Toolbar} from '@mui/material';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import QueryList from '~common/components/query-fulfillment/query-list-fc';

import portalUserContext from '~common/lib/portal-user-context';
import URLManager from '~common/lib/url-manager';

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  toolbar: {
    justifyContent: 'flex-end'
  },
  container: {
    width: '100%',
    // display: 'flex',
    // flexWrap: 'wrap',
    // justifyContent: 'space-around',
    overflow: 'hidden'
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: 'loading' | 'ready';
  error?: any;
};

class LinkAdminQueryList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'ready',
    };
  }

 componentDidMount() {
    // console.log("Into TSX")
  }

  handleActionsForItemRow = (row: any) => {
    var actions = Array<any>()
  
    return actions
  }

  handleRowClick = (item) => {
    var criteria = URLManager.getQueryString(window.location.href)
    window.location.href = `/links/admin/${item.id}?q=${URLManager.getQueryStringValue(criteria)}`
  }

  
  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {status} = this.state;

    var criteriaSelector = {
      "app": "admin",
      "formType": "externalLinkCriteria"
    }

    var resultsFormSelector= {
      "app":"admin",
      "formType":"externalLinkResults"
    }

    criteriaSelector["userType"] = portalUserContext.userType
    if (criteriaSelector["userType"] == "Portal Admin") {
      resultsFormSelector["userType"] = "Internal"
      criteriaSelector["userType"] = "Internal"
    }

    var criteria = URLManager.getQueryString(window.location.href)
    var addNewURL = `/links/admin/new?q=${URLManager.getQueryStringValue(criteria)}`

    switch (status) {
      case 'loading':
        return (
            <div className={classes.container}>
              <LoadingView classes={
                {}
              } />
            </div>
        );
      default:
        return (
            <div className={classes.container}>
                <QueryList
                  criteriaFormSelector={criteriaSelector}
                  resultsFormSelector={resultsFormSelector}
                  queryUrl="/api/links/query"
                  forceExecuteOnLoad={true}
                  autoQuery={true}
                  addNewUrl={addNewURL}
                  supressSectionStatusIcon
                  actionsForItemRow={this.handleActionsForItemRow}
                  onRowClick={this.handleRowClick}
                  alwaysExecuteOnSubmit={true}
                  customRenderers={{}}
                  submitButtonText={"Search"}
                  noResultsText="No Results Found"
              />
            </div>
        );
    }
  }
}

export default withStyles(styles)(LinkAdminQueryList);



